
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Client } from '@/types/client';

interface ContactsSectionProps {
  form: UseFormReturn<Client>;
}

export const ContactsSection: React.FC<ContactsSectionProps> = ({ form }) => {
  return (
    <div className="bg-white p-6 border border-gray-200 rounded-lg">
      <h3 className="text-lg font-montserrat font-semibold text-primary-700 mb-4 flex items-center">
        <div className="w-2 h-2 bg-primary-500 rounded-full mr-2" />
        Contatos
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <FormField
          control={form.control}
          name="phone_number"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 font-medium">Telefone Principal</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                  placeholder="(11) 99999-9999"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="onboarding_contact_phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 font-medium">Contato Onboarding</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                  placeholder="(11) 99999-9999"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="billing_contact_phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 font-medium">Contato Financeiro</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                  placeholder="(11) 99999-9999"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
